import type { NormalizeOAS, OASOutput, OASRequestParams } from 'fets';
import type { ApiClient } from '../fetsClient';
import type openapi from '../openapi';

type O = NormalizeOAS<typeof openapi>;
type RequestParams = OASRequestParams<O, '/api/projects/duplicate', 'post'>;
type ResponseBody = OASOutput<O, '/api/projects/duplicate', 'post'>;

type Params = {
  projectId: number;
};

type Result = number;

export const duplicateProjectFactory = (apiClient: ApiClient) => {
  const duplicateProject = async (variables: Params) => {
    const requestBody = mapInputToRequestBody(variables);
    const response = await apiClient['/api/projects/duplicate'].post(requestBody);
    const responseBody = await response.json();

    return mapResponseToResult(responseBody, variables);
  };

  const mapInputToRequestBody = (input: Params): RequestParams => {
    return {
      json: {
        projectId: input.projectId,
      },
    };
  };

  const mapResponseToResult = (_response: ResponseBody, input: Params): Result => {
    return input.projectId;
  };

  return duplicateProject;
};
